<template>
  <div class="gender-count">
    <div class="gender-right">
      <img :src="[genderIcon]" />
      <div class="gender-counter" v-text="genderCount"></div>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  export default {
    name: 'GenderCount',
    props: {
      male: {
        type: Boolean,
        default: true
      },
      quantity: {
        type: Number,
        default: 0
      },
      symbol: {
        type: String,
        default: ''
      }
    },
    computed: {
      genderText () {
        return this.male ? 'MALE' : 'FEMALE'
      },
      genderIcon () {
        return this.male ? '/static/img/icons/male.svg' : '/static/img/icons/female.svg'
      },
      genderCount () {
        return `${this.quantity}${this.symbol}`
      }
    }
  }
</script>
<style scoped>
  .gender-count {
    display: block;
  }

  .gender-icon {
    display: block;
    float: left;
    width: 33px;
    font-size: 3rem;
  }

  .gender-right {
    display: block;
    float: left;
    margin-top: 0.5rem;
  }

  .gender-text {
    font-size: 0.8rem;
  }

  .gender-counter {
    color: #30AAE1;
    font-size: 2.4rem;
    font-weight: bold;
    margin-top: -37px;
    margin-left: 13px;
  }
  .clear {
    float: none;
    clear: both;
  }
  .fas{
    font-size: 25px;
  }
  .fa-male{
    color: #30aae1;
  }
  .fa-female{
    color: #dd4477;
  }
  .gender-icon{
    width:11px !important;
    height: 18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/GenderCount.vue